import type { BaseConfig, Environment, Region, RegionSpecificConfig } from "./index.ts";

export const values: Record<Environment, Record<"common", BaseConfig> & Record<Region, RegionSpecificConfig>> = {
    msw: {
        common: {
            home: {
                baseUrl: "https://home.core.sharegate-dev.com"
            },
            archives: {
                url: "/archives",
                api: "https://insights-archive-bff.sharegate-dev.com:1347",
                login: "/login",
                logout: "/logout"
            },
            microsoft: {
                adminConsentBase: "/mock/microsoft"
            },
            launch_darkly: {
                client_id: "66a11df757c46d10c12ec337"
            }
        },
        na: {
            insights: {
                api: "https://insights-bff.sharegate-dev.com:1347",
                consentInitiatePage: "/mock/consent/initiate",
                login: "/login",
                logout: "/logout"
            },
            migrate_web: {
                api: "https://migrate-web-api.sharegate-dev.com:1347",
                login: "/auth/login"
            },
            reviews: {
                login: "/reviewer/auth/login"
            },
            sharedReports: {
                login: "/share-recipient/auth/login"
            },
            app_registrations: {
                insights: "f9a2fbcc-39c2-42e4-8286-a743bf50ab18",
                remediation: "d8035666-36bc-4b3e-89e1-fe2093eb51c3",
                migrate: "49c58e7e-3236-4c26-9b9e-07e1cdddba72",
                archive: "ab9ac53c-1ab5-4a34-b581-78be45b233b5"
            },
            google: {
                app_id: "1031279079075-jqvriaso61r058tht8ffg47db1n0mcud.apps.googleusercontent.com",
                oauth_client_id: "114384360030086544726"
            }
        },
        eu: {
            insights: {
                api: "https://insights-eu-bff.sharegate-dev.com:1347",
                consentInitiatePage: "/mock/consent/initiate",
                login: "/login",
                logout: "/logout"
            },
            migrate_web: {
                api: "https://migrate-web-api.sharegate-dev.com:1347",
                login: "/auth/login"
            },
            reviews: {
                login: "/reviewer/auth/login"
            },
            sharedReports: {
                login: "/share-recipient/auth/login"
            },
            app_registrations: {
                insights: "d8ee8372-dfe5-4de8-b05d-45c9ea3d0fe6",
                remediation: "d1f84b44-9c73-47bd-87e4-07fcf6f51c71",
                migrate: "b9576087-72a4-4f07-b24f-2f37614b2f90",
                archive: "ab9ac53c-1ab5-4a34-b581-78be45b233b5"
            },
            google: {
                app_id: "1031279079075-jqvriaso61r058tht8ffg47db1n0mcud.apps.googleusercontent.com",
                oauth_client_id: "109443686763466667371"
            }
        }
    },
    local: {
        common: {
            home: {
                baseUrl: "https://home.core.sharegate-dev.com"
            },
            archives: {
                url: "/archives",
                api: "https://insights-archive-bff.sharegate-dev.com:1347",
                login: "https://insights-archive-bff.sharegate-dev.com:1347/auth/login",
                logout: "https://insights-archive-bff.sharegate-dev.com:1347/auth/logout"
            },
            microsoft: {
                adminConsentBase: "https://login.microsoftonline.com"
            },
            launch_darkly: {
                client_id: "66a11df757c46d10c12ec337"
            }
        },
        na: {
            insights: {
                api: "https://insights.sharegate-dev.com:1347",
                consentInitiatePage: "https://insights.sharegate-dev.com:1347/bff/consent/initiate",
                login: "https://insights.sharegate-dev.com:1347/bff/auth/login",
                logout: "https://insights.sharegate-dev.com:1347/bff/auth/logout"
            },
            migrate_web: {
                api: "https://migrate-web-api.sharegate-dev.com:1347",
                login: "https://migrate-web-api.sharegate-dev.com:1347/auth/login"
            },
            reviews: {
                login: "https://insights.sharegate-dev.com:1347/reviewer/auth/login"
            },
            sharedReports: {
                login: "https://insights.sharegate-dev.com:1347/share-recipient/auth/login"
            },
            app_registrations: {
                insights: "f9a2fbcc-39c2-42e4-8286-a743bf50ab18",
                remediation: "d8035666-36bc-4b3e-89e1-fe2093eb51c3",
                migrate: "49c58e7e-3236-4c26-9b9e-07e1cdddba72",
                archive: "ab9ac53c-1ab5-4a34-b581-78be45b233b5"
            },
            google: {
                app_id: "1031279079075-jqvriaso61r058tht8ffg47db1n0mcud.apps.googleusercontent.com",
                oauth_client_id: "114384360030086544726"
            },
            logrocket: {
                app_id: "27bhmd/sharegate-test"
            }
        },
        eu: {
            insights: {
                api: "https://insights.sharegate-dev.com:1347",
                consentInitiatePage: "https://insights.sharegate-dev.com:1347/bff/consent/initiate",
                login: "https://insights.sharegate-dev.com:1347/bff/auth/login",
                logout: "https://insights.sharegate-dev.com:1347/bff/auth/logout"
            },
            migrate_web: {
                api: "https://migrate-web-api.sharegate-dev.com:1347",
                login: "https://migrate-web-api.sharegate-dev.com:1347/auth/login"
            },
            reviews: {
                login: "https://insights.sharegate-dev.com:1347/reviewer/auth/login"
            },
            sharedReports: {
                login: "https://insights.sharegate-dev.com:1347/share-recipient/auth/login"
            },
            app_registrations: {
                insights: "f9a2fbcc-39c2-42e4-8286-a743bf50ab18",
                remediation: "d8035666-36bc-4b3e-89e1-fe2093eb51c3",
                migrate: "49c58e7e-3236-4c26-9b9e-07e1cdddba72",
                archive: "ab9ac53c-1ab5-4a34-b581-78be45b233b5"
            },
            google: {
                app_id: "1031279079075-jqvriaso61r058tht8ffg47db1n0mcud.apps.googleusercontent.com",
                oauth_client_id: "109443686763466667371"
            }
        }
    },
    development: {
        common: {
            home: {
                baseUrl: "https://home.core.sharegate-dev.com"
            },
            archives: {
                url: "/archives",
                api: "https://api.protect.sharegate-dev.com/archive-web/",
                login: "https://api.protect.sharegate-dev.com/archive-web/auth/login",
                logout: "https://api.protect.sharegate-dev.com/archive-web/auth/logout"
            },
            intercom: {
                app_id: "rwpjmnq9"
            },
            microsoft: {
                adminConsentBase: "https://login.microsoftonline.com"
            },
            launch_darkly: {
                client_id: "66a11df757c46d10c12ec337"
            }
        },
        na: {
            insights: {
                api: "https://api.protect.sharegate-dev.com/insights",
                consentInitiatePage: "https://api.protect.sharegate-dev.com/insights/bff/consent/initiate",
                login: "https://api.protect.sharegate-dev.com/insights/bff/auth/login",
                logout: "https://api.protect.sharegate-dev.com/insights/bff/auth/logout"
            },
            migrate_web: {
                api: "https://api.migrate.sharegate-dev.com/",
                login: "https://api.migrate.sharegate-dev.com/auth/login"
            },
            reviews: {
                login: "https://api.protect.sharegate-dev.com/insights/reviewer/auth/login"
            },
            sharedReports: {
                login: "https://api.protect.sharegate-dev.com/insights/share-recipient/auth/login"
            },
            app_registrations: {
                insights: "f9a2fbcc-39c2-42e4-8286-a743bf50ab18",
                remediation: "d8035666-36bc-4b3e-89e1-fe2093eb51c3",
                migrate: "49c58e7e-3236-4c26-9b9e-07e1cdddba72",
                archive: "ab9ac53c-1ab5-4a34-b581-78be45b233b5"
            },
            google: {
                app_id: "1031279079075-jqvriaso61r058tht8ffg47db1n0mcud.apps.googleusercontent.com",
                oauth_client_id: "114384360030086544726"
            },
            honeycomb: {
                proxy: "https://api.core.sharegate-dev.com/authentication.proxy/proxy/otel/v1/traces"
            },
            mixpanel_session_replay: {
                proxy: "https://api.core.sharegate-dev.com/authentication.proxy/proxy/mp/api",
                lib_base_path: "https://api.core.sharegate-dev.com/authentication.proxy/proxy/mp/libs/"
            }
        },
        eu: {
            insights: {
                api: "https://api.eu.protect.sharegate-dev.com/insights",
                consentInitiatePage: "https://api.eu.protect.sharegate-dev.com/insights/bff/consent/initiate",
                // We can't provision a different logout urls for NA and EU, so authentication must be done against the NA endpoint
                login: "https://api.protect.sharegate-dev.com/insights/bff/auth/login",
                logout: "https://api.protect.sharegate-dev.com/insights/bff/auth/logout"
            },
            migrate_web: {
                api: "https://api.eu.migrate.sharegate-dev.com/",
                login: "https://api.migrate.sharegate-dev.com/auth/login"
            },
            reviews: {
                login: "https://api.eu.protect.sharegate-dev.com/insights/reviewer/auth/login"
            },
            sharedReports: {
                login: "https://api.eu.protect.sharegate-dev.com/insights/share-recipient/auth/login"
            },
            app_registrations: {
                insights: "d8ee8372-dfe5-4de8-b05d-45c9ea3d0fe6",
                remediation: "d1f84b44-9c73-47bd-87e4-07fcf6f51c71",
                migrate: "b9576087-72a4-4f07-b24f-2f37614b2f90",
                archive: "ab9ac53c-1ab5-4a34-b581-78be45b233b5"
            },
            google: {
                app_id: "1031279079075-jqvriaso61r058tht8ffg47db1n0mcud.apps.googleusercontent.com",
                oauth_client_id: "109443686763466667371"
            },
            honeycomb: {
                proxy: "https://api.eu.core.sharegate-dev.com/authentication.proxy/proxy/otel/v1/traces"
            }
        }
    },
    staging: {
        common: {
            home: {
                baseUrl: "https://home.core.sharegate-stg.com"
            },
            archives: {
                url: "https://protect.sharegate-stg.com/archives/",
                api: "https://api.protect.sharegate-stg.com/archive-web/",
                login: "https://api.protect.sharegate-stg.com/archive-web/auth/login",
                logout: "https://api.protect.sharegate-stg.com/archive-web/auth/logout"
            },
            intercom: {
                app_id: "rwpjmnq9"
            },
            microsoft: {
                adminConsentBase: "https://login.microsoftonline.com"
            },
            launch_darkly: {
                client_id: "66bcfdf38f2bee103df471e7"
            }
        },
        na: {
            insights: {
                api: "https://api.protect.sharegate-stg.com/insights",
                consentInitiatePage: "https://api.protect.sharegate-stg.com/insights/bff/consent/initiate",
                login: "https://api.protect.sharegate-stg.com/insights/bff/auth/login",
                logout: "https://api.protect.sharegate-stg.com/insights/bff/auth/logout"
            },
            migrate_web: {
                api: "https://api.migrate.sharegate-stg.com/",
                login: "https://api.migrate.sharegate-stg.com/auth/login"
            },
            reviews: {
                login: "https://api.protect.sharegate-stg.com/insights/reviewer/auth/login"
            },
            sharedReports: {
                login: "https://api.protect.sharegate-stg.com/insights/share-recipient/auth/login"
            },
            app_registrations: {
                insights: "f00b1d77-79c1-4dcb-94be-5ec6b91f95ba",
                remediation: "0fbcb083-d010-4933-8e52-fc1706b4f4d2",
                migrate: "2022ad7d-6cf4-4520-952a-fe669d00a47e",
                archive: "9ecbd0c3-1dac-463d-91cc-ad59c0585e3e"
            },
            google: {
                app_id: "1044327871822-3pas8offjp0j5g5l93spmberumdobg9d.apps.googleusercontent.com",
                oauth_client_id: "105306219292493264181"
            },
            logrocket: {
                app_id: "27bhmd/sharegate-test"
            },
            honeycomb: {
                proxy: "https://api.core.sharegate-stg.com/authentication.proxy/proxy/otel/v1/traces"
            },
            mixpanel_session_replay: {
                proxy: "https://api.core.sharegate-stg.com/authentication.proxy/proxy/mp/api",
                lib_base_path: "https://api.core.sharegate-stg.com/authentication.proxy/proxy/mp/libs/"
            }
        },
        eu: {
            insights: {
                api: "https://api.eu.protect.sharegate-stg.com/insights",
                consentInitiatePage: "https://api.eu.protect.sharegate-stg.com/insights/bff/consent/initiate",
                // We can't provision a different logout urls for NA and EU, so authentication must be done against the NA endpoint
                login: "https://api.protect.sharegate-stg.com/insights/bff/auth/login",
                logout: "https://api.protect.sharegate-stg.com/insights/bff/auth/logout"
            },
            migrate_web: {
                api: "https://api.eu.migrate.sharegate-stg.com/",
                login: "https://api.migrate.sharegate-stg.com/auth/login"
            },
            reviews: {
                login: "https://api.eu.protect.sharegate-stg.com/insights/reviewer/auth/login"
            },
            sharedReports: {
                login: "https://api.eu.protect.sharegate-stg.com/insights/share-recipient/auth/login"
            },
            app_registrations: {
                insights: "8c4d9787-b715-4817-9608-7ba07985920b",
                remediation: "387634ac-5165-4ec6-9d0e-13eddd37a5db",
                migrate: "d7c3a8e8-dc54-4e77-930c-272f802fa2c2",
                archive: "9ecbd0c3-1dac-463d-91cc-ad59c0585e3e"
            },
            google: {
                app_id: "1044327871822-3pas8offjp0j5g5l93spmberumdobg9d.apps.googleusercontent.com",
                oauth_client_id: "110188423471924949532"
            },
            honeycomb: {
                proxy: "https://api.eu.core.sharegate-stg.com/authentication.proxy/proxy/otel/v1/traces"
            }
        }
    },
    production: {
        common: {
            home: {
                baseUrl: "https://home.sharegate.com"
            },
            archives: {
                url: "https://protect.sharegate.com/archives/",
                api: "https://api.protect.sharegate.com/archive-web/",
                login: "https://api.protect.sharegate.com/archive-web/auth/login",
                logout: "https://api.protect.sharegate.com/archive-web/auth/logout"
            },
            intercom: {
                app_id: "dl18ndva"
            },
            microsoft: {
                adminConsentBase: "https://login.microsoftonline.com"
            },
            launch_darkly: {
                client_id: "66a11df757c46d10c12ec338"
            }
        },
        na: {
            insights: {
                api: "https://api.protect.sharegate.com/insights",
                consentInitiatePage: "https://api.protect.sharegate.com/insights/bff/consent/initiate",
                login: "https://api.protect.sharegate.com/insights/bff/auth/login",
                logout: "https://api.protect.sharegate.com/insights/bff/auth/logout"
            },
            migrate_web: {
                api: "https://api.migrate.sharegate.com/",
                login: "https://api.migrate.sharegate.com/auth/login"
            },
            reviews: {
                login: "https://api.protect.sharegate.com/insights/reviewer/auth/login"
            },
            sharedReports: {
                login: "https://api.protect.sharegate.com/insights/share-recipient/auth/login"
            },
            app_registrations: {
                insights: "b4ee5078-7f3c-418b-a13e-10a7481ae6dc",
                remediation: "d2d28943-073b-48d2-a917-8f7a13287942",
                migrate: "efa7be35-eb8c-4868-b3c6-a531dc28801c",
                archive: "fc6e8c0d-0316-409c-a5ef-cd4c9ae41331"
            },
            google: {
                app_id: "467554011590-1tp132dgp7cnka1eubn8oal4ae021pog.apps.googleusercontent.com",
                oauth_client_id: "114335206116188753672"
            },
            logrocket: {
                app_id: "27bhmd/sharegate"
            },
            honeycomb: {
                proxy: "https://api.core.sharegate.com/authentication.proxy/proxy/otel/v1/traces"
            },
            mixpanel_session_replay: {
                proxy: "https://api.core.sharegate.com/authentication.proxy/proxy/mp/api",
                lib_base_path: "https://api.core.sharegate.com/authentication.proxy/proxy/mp/libs/"
            }
        },
        eu: {
            insights: {
                api: "https://api.eu.protect.sharegate.com/insights",
                consentInitiatePage: "https://api.eu.protect.sharegate.com/insights/bff/consent/initiate",
                // We can't provision a different logout urls for NA and EU, so authentication must be done against the NA endpoint
                login: "https://api.protect.sharegate.com/insights/bff/auth/login",
                logout: "https://api.protect.sharegate.com/insights/bff/auth/logout"
            },
            migrate_web: {
                api: "https://api.eu.migrate.sharegate.com/",
                login: "https://api.migrate.sharegate.com/auth/login"
            },
            reviews: {
                login: "https://api.eu.protect.sharegate.com/insights/reviewer/auth/login"
            },
            sharedReports: {
                login: "https://api.eu.protect.sharegate.com/insights/share-recipient/auth/login"
            },
            app_registrations: {
                insights: "6f594e45-4546-4ff9-a839-ea55426ccbc7",
                remediation: "07fabd14-a56e-42c1-ab24-23512756c19b",
                migrate: "7d1d37bb-6f6b-4539-88e2-a8e32214f87b",
                archive: "fc6e8c0d-0316-409c-a5ef-cd4c9ae41331"
            },
            google: {
                app_id: "467554011590-1tp132dgp7cnka1eubn8oal4ae021pog.apps.googleusercontent.com",
                oauth_client_id: "106803897618316196622"
            },
            honeycomb: {
                proxy: "https://api.eu.core.sharegate.com/authentication.proxy/proxy/otel/v1/traces"
            }
        }
    }
};
